import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Loading from "./loading";
import EvaluationStatusEnum from "./evaluationStatusEnum";
import EnterEntryCodeForm from "./enterEntryCodeForm";
import Begin from "./begin";
import NewAttempt from "./newAttempt";
import useNavigateToLoginPageEnv from "./useNavigateToLoginPageEnv";
import DefaultNotAble from "./defaultNotAble";
import Continue from "./continue";

const Evaluation = () => {
    const navigateToLoginPageEnv = useNavigateToLoginPageEnv();
    const { courseCode, assessmentCode } = useParams();
    const [status, setStatus] = useState("");
    const [beginOrNew, setBeginOrNew] = useState("");
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);

    function updateStatus(status) {
        setStatus(status);
    }

    function updateBeginOrNew(string) {
        setBeginOrNew(string);
    }

    const findStatusOfEval = async () => {
        try {
            setRequestLifeCycle(true);
            const response = await fetch( process.env.REACT_APP_EVALUATION_API_URL  + `/get-evaluation-status/${courseCode}/${assessmentCode}`, {
                method: "GET",
                credentials: "include"
            });
            const data = await response.json();

            // if correct -> show continute
            if (response.status === 200) {
                setStatus(EvaluationStatusEnum.CONTINUE)
            // handle begin
            } else if (response.status === 450) {
                setStatus(EvaluationStatusEnum.BEGIN)
            // catch expected errors
            } else if (response.status === 451 || response.status === 452 || response.status === 455 || response.status === 456) {
                setStatus(EvaluationStatusEnum.ERROR)
            // handle new attempt
            } else if (response.status === 453) {
                setStatus(EvaluationStatusEnum.NEW_ATTEMPT)
            // auth
            } else if (response.status === 401) {
                navigateToLoginPageEnv();
            // wild card catch
            } else {
                alert("Status Code: " + response.status + " Error: " + data.detail);
                updateStatus(EvaluationStatusEnum.ERROR);
            }
        } catch (error) {            
            alert("Error: " + error.message);
            updateStatus(EvaluationStatusEnum.ERROR);
        } finally {
            setRequestLifeCycle(false);
        }
    }

    useEffect(() => {
        findStatusOfEval();
    }, [])

    const pageToReturn = () => {
        switch (status) {
            case EvaluationStatusEnum.NOT_ENTERED_ENTRY_CODE: {
                return <EnterEntryCodeForm beginOrNew={beginOrNew} updateStatus={updateStatus}/>
            }
            case EvaluationStatusEnum.BEGIN: {
                return <Begin updateBeginOrNew={updateBeginOrNew} updateStatus={updateStatus}/>
            }
            case EvaluationStatusEnum.NEW_ATTEMPT: {
                return <NewAttempt updateBeginOrNew={updateBeginOrNew} updateStatus={updateStatus}/>
            }
            case EvaluationStatusEnum.CONTINUE: {
                return <Continue />
            }
            default: {
                return <DefaultNotAble />
            }
        }
    }

    return (
        <>
            {
                requestLifeCycle

                ?

                <>
                    <div className="total-2">
                        <Loading />
                    </div>
                </>

                :

                <>
                    {
                        pageToReturn()
                    }
                </>

            }
        </>
    );
}

export default Evaluation;